module.exports = __webpack_public_path__ + "static/media/gym-squad-activewear-900x643.de4dcb98.webp";